import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndicadorFormComponent } from './indicador-form/indicador-form.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { IMaskModule } from 'angular-imask';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { SharedModule, Max100Pipe } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AcaoGovernoAdicionalDlgComponent } from '../acao-governo-adicional-dlg/acao-governo-adicional-dlg.component';

@NgModule({
  declarations: [
    IndicadorFormComponent,
    Max100Pipe,
    AcaoGovernoAdicionalDlgComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    ConfirmDialogModule,
    IMaskModule,
    ToastModule,
    FormsModule
  ],
  exports: [IndicadorFormComponent],
  providers: [ConfirmationService]
})
export class IndicadorModule { }
